import React, { useContext, createContext } from 'react'
import PropTypes from 'prop-types'

import { hasWindow } from 'util/dom'
import theme from 'theme'

const breakpoints = theme.breakpoints.map((b) =>
  parseInt(b.replace('px', ''), 10)
)

const getBreakpoint = () => {
  // render for desktop in SSR
  if (!hasWindow) return breakpoints.length - 1

  const { innerWidth } = window

  if (innerWidth > breakpoints[breakpoints.length - 1]) {
    return breakpoints.length - 1
  }

  for (let i = 0; i < breakpoints.length; i += 1) {
    if (innerWidth <= breakpoints[i]) {
      return i
    }
  }

  return breakpoints.length - 1
}

const context = createContext({})

export const BreakpointProvider = ({ children }) => {
  const [breakpoint, setBreakpoint] = React.useState(() => getBreakpoint())

  const handleWindowResize = () => {
    setBreakpoint(getBreakpoint)
  }

  React.useEffect(() => {
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  return <context.Provider value={breakpoint}>{children}</context.Provider>
}

BreakpointProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useBreakpoints = () => useContext(context)

export const useIsMobile = () => useContext(context) <= 1
